import { useEffect, useState } from "react";
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetDescription } from "@/components/ui/sheet";
import { adapter } from "@/services/db";
import { fmtTs, toDate } from "@/lib/format";

const TONE = { category_created: "text-emerald-700", category_unblocked: "text-emerald-700", category_blocked: "text-red-700", category_auto_ended: "text-red-700", category_deleted: "text-red-700" };

export function CategoryLog({ cat, onClose }) {
  const [logs, setLogs] = useState([]);
  useEffect(() => {
    if (!cat) return undefined;
    return adapter.subscribeWhere("activity_logs", [["entity_type", "==", "categories"], ["entity_id", "==", cat.id]],
      (l) => setLogs(l.sort((a, b) => (toDate(b.created_at)?.getTime() || 0) - (toDate(a.created_at)?.getTime() || 0))));
  }, [cat]);
  return (
    <Sheet open={!!cat} onOpenChange={(o) => !o && onClose()}>
      <SheetContent className="w-full sm:max-w-lg overflow-y-auto" data-testid="category-log-drawer">
        {cat && (
          <>
            <SheetHeader className="text-left">
              <SheetTitle className="font-heading">{cat.name} · log</SheetTitle>
              <SheetDescription className="font-mono">{cat.id}</SheetDescription>
            </SheetHeader>
            <div className="mt-4 grid grid-cols-2 gap-2 text-xs" data-testid="category-timeline">
              {[["Created", fmtTs(cat.created_at)], ["Live since", fmtTs(cat.active_from || cat.created_at)], ["Blocked / ended", fmtTs(cat.blocked_at || cat.ended_at)], ["Scheduled end", fmtTs(cat.scheduled_end_at)], ["Blocked by", cat.blocked_by || "—"], ["Block reason", cat.blocked_reason || "—"]].map(([k, v]) => (
                <div key={k} className="rounded-lg border border-border bg-secondary/50 p-2.5"><p className="text-[10px] font-mono uppercase tracking-wider text-muted-foreground">{k}</p><p className="mt-0.5 text-foreground break-words">{v}</p></div>
              ))}
            </div>
            <ol className="mt-5 space-y-2" data-testid="category-log-list">
              {logs.map((l) => (
                <li key={l.id} className="rounded-lg border border-border p-3" data-testid={`category-log-${l.id}`}>
                  <p className={`text-xs font-mono font-semibold ${TONE[l.action] || "text-foreground"}`}>{l.action}</p>
                  <p className="text-[11px] text-muted-foreground">{l.performed_by || "—"} · {fmtTs(l.created_at)}</p>
                  {l.reason && <p className="text-xs mt-1">Reason: {l.reason}</p>}
                  {l.description && <p className="text-xs text-muted-foreground">{l.description}</p>}
                </li>
              ))}
              {logs.length === 0 && <p className="text-xs text-muted-foreground text-center py-6">No logged events yet (events are recorded from now on).</p>}
            </ol>
          </>
        )}
      </SheetContent>
    </Sheet>
  );
}
